import { Box, CloseButton, Flex, Link, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { useSub } from "../../../../common/subscription/useSub";
import { urls } from "../../../../urls";

export const BidInsightAddOnNote = () => {
  const { t } = useTranslation();
  const sub = useSub();
  const personId = useLoggedInWithOrgContextState().me.id;
  const dismissal = bidInsightNoteDismissalFor(personId);
  const [dismissed, setDismissed] = useState(dismissal.dismissed);

  if (dismissed) return null;

  const dismiss = () => {
    dismissal.remember();
    setDismissed(true);
  };

  return (
    <Flex borderWidth="1px" borderColor="smBorder" rounded="md" px="3" py="2" mb="4" gap="3" align="start">
      <Box flex="1">
        <Text fontSize="sm" color="smMuted">
          {t("Bid insight is available as an add-on: an AI summary of each bid you receive.")}{" "}
          {sub.canUpdateOrganization ? (
            <Link as={RouterLink} to={`${urls.app.settings}?tab=ai`} color="smPrimary">
              {t("See AI skills")}
            </Link>
          ) : (
            t("An administrator in your organization can ask for it.")
          )}
        </Text>
      </Box>
      <CloseButton size="sm" onClick={dismiss} aria-label={String(t("Hide the note about bid insight"))} />
    </Flex>
  );
};

export const bidInsightNoteDismissalFor = (personId: string) => {
  const key = `bid-insight-add-on-dismissed:${personId}`;
  return {
    dismissed: (): boolean => {
      try {
        return localStorage.getItem(key) !== null;
      } catch {
        return false;
      }
    },
    remember: () => {
      try {
        localStorage.setItem(key, new Date().toISOString());
      } catch {
        return;
      }
    },
  };
};
